import { useEffect, createContext, useState} from 'react';
import { Route, Routes,Router,Navigate , useNavigate} from 'react-router-dom';
import { Outlet } from "react-router"
import { PageLayout } from './components/PageLayout';
import { Home } from './pages/Home';
import { WebMapView } from './pages/Map';
import Login from './Login';
import styled from 'styled-components';
import './styles/App.css';
import { WebMap } from '@esri/react-arcgis';
import LoginService from "./services/login.service";
import EditorHome from './pages/EditorHome';
import  AuthProvider  from './context/AuthContext.jsx';

const Pages = () => {
    return (
        <Routes>
          <Route path="/s4l/login" element={<Login />} />
          <Route path="/s4l/" element={<Login />} />               
          <Route path="/s4l/map" element={<ProtectedRoute element={<WebMapView />} />} />
          <Route path="/s4l/editor-home" element={<ProtectedRoute element={<EditorHome />} />} />
          {/* <Route path="/s4l/login" element={<ProtectedRoute element={<EditorHome />} />} />
          <Route path="/s4l/" element={<ProtectedRoute element={<EditorHome />} />} /> */}    
        </Routes>
    );
};
const Styles = styled.div`
    .webmap {
    position: absolute;
    z-index: 1;
    width: 65%;
    height: 100%; 
    }
`;

const  App = () => {
    const UserContext = createContext();
    const [isLogedIn,setIsLogedIn] = useState(false);
    const handleClick = () => {
        setIsLogedIn(!isLogedIn);
    }

    return (
         <AuthProvider>
            <PageLayout>
              <Pages />
            </PageLayout>
         </AuthProvider>
    );
}

  const ProtectedRoute = ({ element }) => {
    console.log(element);
    return auth.isAuthenticated() ? element : <Navigate to="/s4l/login" />; 
  };

 /*  const ProtectedRouteCS = ({ element }) => {
    if (auth.isAuthenticated()) {
      if ( element=={<Login />} )

    } 
    else {
      return <Navigate to="/s4l/login"
    } 
    // return true ? element : <Navigate to="/s4l/login" />; 
    return auth.isAuthenticated() ? <Navigate to="/s4l/editor-home" /> : <Navigate to="/s4l/login" />; 
  }; */
  
  const auth = {
    isAuthenticated() {
      let s4lUser = localStorage.getItem('s4l')? JSON.parse(localStorage.getItem('s4l')) : null; 
      if(!s4lUser){
        return false;
      }
      let hours = 8;
      let saved = s4lUser.time;
      if(!saved){
        return false;
      }
      if (saved && (new Date().getTime() - saved > hours * 60 * 60 * 1000)) {
        localStorage.clear();
        return false;
      }
      return true;
    },
  };
export default App;